module.exports = __webpack_public_path__ + "media/track_guides/premium_preview-824a5f69.png";